import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { useLanguage } from "@/i18n";
import { scrollToId } from "@/pages/Landing";

const LANGS = ["pt", "en", "de"];

export const Header = ({ settings }) => {
  const { lang, setLang, t } = useLanguage();
  const [open, setOpen] = useState(false);
  const links = [
    ["#artists", t("nav_artists")],
    ["#portfolio", t("nav_portfolio")],
    ["#manifesto", t("nav_manifesto")],
    ["#space", t("nav_space")],
    ["#booking", t("nav_booking")],
    ["#location", t("nav_location")],
  ];
  const go = (id) => { setOpen(false); scrollToId(id); };

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#0A0A0B]/80 border-b border-white/10" data-testid="main-navigation">
      <div className="px-4 sm:px-8 lg:px-16 h-16 flex items-center justify-between">
        <button onClick={() => go("#top")} data-testid="nav-logo" className="font-display text-2xl tracking-widest uppercase">
          {settings.studio_name || "STUDIO"}
        </button>
        <nav className="hidden lg:flex items-center gap-8">
          {links.map(([id, label]) => (
            <button key={id} onClick={() => go(id)} data-testid={`nav-link-${id.slice(1)}`}
              className="font-mono2 text-[11px] tracking-[0.25em] uppercase text-zinc-400 hover:text-white transition-colors duration-300">
              {label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-1 border border-white/15 px-1 py-0.5" data-testid="language-switcher">
            {LANGS.map((l) => (
              <button key={l} onClick={() => setLang(l)} data-testid={`lang-switch-${l}`}
                className={`font-mono2 text-[10px] tracking-widest uppercase px-2 py-1 transition-colors duration-300 ${lang === l ? "bg-white text-black" : "text-zinc-500 hover:text-white"}`}>
                {l}
              </button>
            ))}
          </div>
          <button className="lg:hidden" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="menu">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }}
            className="lg:hidden overflow-hidden border-t border-white/10" data-testid="mobile-menu">
            {links.map(([id, label]) => (
              <button key={id} onClick={() => go(id)} data-testid={`mobile-nav-${id.slice(1)}`}
                className="block w-full text-left px-6 py-4 font-mono2 text-xs tracking-[0.25em] uppercase text-zinc-300 border-b border-white/5">
                {label}
              </button>
            ))}
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
